import * as React from "react";
import territory, { getMarketOptions, getTerritoriesOptions } from "../../territory";
import territoryProductType from "../../territory-product-type";
import territoryMarket from "../../territory-market";
import Dropdown from "../Dropdown/Dropdown";


const TeamMemberTerritoryInfo = ({viewMode, deleted, addTerritory, territoryArray, handleTerritoryChangeDropdown, removeTerritory, errorIndex=[]}) => {
    
    return (
        <div className="Team-member-territory-info">
            {territoryArray.map((territoryData, index) => (
                    <div className={`Team-member-territory-info-column`} key={index}>    
                        <Dropdown
                        className="Team-member-territory-info-column_item"
                        data={territoryData}
                        options={territoryProductType}
                        value={territoryData.type}
                        valueKey="type"
                        label="Product Type"
                        handleParentChange={(...rest)=>{handleTerritoryChangeDropdown(...rest, index)}}
                        viewMode={viewMode}
                        deleted={deleted}
                        dropdownType="single"
                        optionsType="productType"
                        optionLabelKey='name'
                        optionKey='code'
                    />
                    <Dropdown
                        className="Team-member-territory-info-column_item"
                        data={territoryData}
                        options={getMarketOptions(territoryData)||[]}
                        value={territoryData.market}
                        valueKey="market"
                        label="Market"
                        handleParentChange={(...rest)=>{handleTerritoryChangeDropdown(...rest, index)}}
                        viewMode={viewMode}
                        deleted={deleted}
                        dropdownType="single"
                        optionsType="territoryMarket"
                        optionLabelKey='name'
                        optionKey='code'
                    />      
                    <Dropdown
                        className="Team-member-territory-info-column_item"
                        data={territoryData}
                        optionKey='code'
                        optionLabelKey='name'
                        options={getTerritoriesOptions(territoryData)|| []}
                        value={territoryData.territory}
                        valueKey="territory"
                        label="Territory"
                        handleParentChange={(...rest)=>{handleTerritoryChangeDropdown(...rest, index)}}
                        viewMode={viewMode}
                        deleted={deleted}
                        dropdownType="single"
                        optionsType="territory"
                    />
                    {!viewMode && <button
                            type="button"
                            className={`button-new negative add-territory-button`}
                            disabled={viewMode}
                            onClick={()=>removeTerritory(index)}>
                            Remove
                        </button>}
                </div>
            ))}
                <button
                    type="button"
                    className={`button-new positive add-territory-button ${viewMode ? 'disabled': ''}`}
                    disabled={viewMode}
                    onClick={addTerritory}>
                    Add Territory
                </button>
            </div>
    );
};

export default TeamMemberTerritoryInfo;
